interface StatusToolbarProps {
  /** "09:00 – 10:30", or null when nothing is selected. */
  range: string | null
  /** "1 h 30 m" */
  duration: string | null
  /** What fills the selection, or how many blocks it spans. */
  filledWith: string | null
  /** Selection is held rather than advancing after each mark. */
  sticky: boolean
  clipboardSize: number
  onPaste: () => void
  /** "last entry 2 h ago", shown only when idle. */
  idleHint: string | null
}

/**
 * The strip between timeline and picker.
 *
 * Its whole job is to answer "what am I about to change?" without the user
 * having to look back up at the timeline.
 */
export function StatusToolbar({
  range,
  duration,
  filledWith,
  sticky,
  clipboardSize,
  onPaste,
  idleHint,
}: StatusToolbarProps) {
  if (!range) {
    return (
      <div className="tl-status tl-status--idle">
        <span className="tl-status-hint">
          {idleHint ?? 'Tap a block, or hold and drag to select a range'}
        </span>
      </div>
    )
  }

  return (
    <div className="tl-status">
      <span className="tl-status-range">{range}</span>
      {duration ? <span className="tl-status-duration">{duration}</span> : null}
      {sticky ? (
        <span className="tl-status-badge" title="Selection is held after marking">
          held
        </span>
      ) : null}
      {filledWith ? <span className="tl-status-filled">{filledWith}</span> : null}
      {clipboardSize > 0 ? (
        <button className="tl-status-paste" onClick={onPaste}>
          Paste {clipboardSize}
        </button>
      ) : null}
    </div>
  )
}
